import { useQuickFilterSearchParam } from 'src/hooks/useQuickFilters';

/**
 * Sentinel value stored in the shared `quickFilterId` URL param when the
 * "Placeholder Events" quick filter is active. Reusing the single-selection quick
 * filter param (rather than a dedicated one) makes the placeholder chip mutually
 * exclusive with the other quick filters for free: selecting any other chip
 * overwrites the param and deselects placeholder, with no extra state or effects.
 */
export const PLACEHOLDER_EVENTS_QUICK_FILTER_ID = 'placeholderEvents';

/**
 * Whether the "Placeholder Events" quick filter is active. Backed by the stateful
 * URL (`quickFilterId=placeholderEvents`), so it survives refresh and is shareable,
 * and it is not a user setting. Applied purely client-side in CatalogDataContextV2
 * via `searchEvents(..., placeholderOnly)`.
 */
export const useIsPlaceholderEventsOnly = (): boolean =>
  useQuickFilterSearchParam() === PLACEHOLDER_EVENTS_QUICK_FILTER_ID;
